import { Dialog } from '@mui/material'
import { FC, PropsWithChildren, useContext } from 'react'
import { LogoButton } from 'components/common/Button/LogoButton'
import {
  CloseAbsoluteDiv,
  CloseIconContainer,
  ModalBody
} from './AuthModal.style'
import { AuthModalContext, ModalState } from './AuthModalContext'

interface AuthModalProps extends PropsWithChildren<{}> {
  // true is used to open model for reset password or expired reset password link
  modalState: ModalState | true
}

export const AuthModal: FC<AuthModalProps> = ({ modalState, children }) => {
  const {
    modalParams: { state },
    setModalParams
  } = useContext(AuthModalContext)

  const onClose = () =>
    setModalParams({
      state: 'CLOSED',
      redirectUrl: '',
      email: '',
      sponsors: undefined
    })

  return (
    <Dialog
      fullWidth
      sx={{
        '.MuiPaper-root': {
          width: '416px',
          height: 'auto'
        }
      }}
      open={typeof modalState === 'boolean' ? modalState : state === modalState}
      onClose={onClose}
    >
      <ModalBody>
        <CloseAbsoluteDiv>
          <LogoButton
            onClick={onClose}
            icon={<CloseIconContainer />}
            noBorder
          />
        </CloseAbsoluteDiv>
        {children}
      </ModalBody>
    </Dialog>
  )
}
